import { priceBookclient } from "./index";

export const getEquipments = (token, country) => priceBookclient.get(`get_products?country=${country}`, { headers: { "Authorization": `Bearer ${token}` } });
// export const getCustomers = (token) => priceBookclient.get(`pricebook/get_customers`, { headers: { "Authorization": `Bearer ${token}` } });
export const getRegions = (token) => priceBookclient.get(`get_regions`, { headers: { "Authorization": `Bearer ${token}` } });
export const savePriceBook = (payload, token) => priceBookclient.post(`save_pricebook`, payload, { headers: { "Authorization": `Bearer ${token}` } });

export const getPriceBook = (token, filters) => priceBookclient.get(`get_orders?Sales=${filters.search_sales}&Customer=${filters.search_customer}&Version=${filters?.search_version}&Region=${filters.search_region}&start_date=${filters.start_date}&end_date=${filters.end_date}&is_active=${filters.is_active}&page=${filters.page}&page_size=${filters.page_size}`, { headers: { "Authorization": `Bearer ${token}` } });
export const getPriceBookById = (token, id) => priceBookclient.get(`get_order_details?order_id=${id}`, { headers: { "Authorization": `Bearer ${token}` } });

export const updatePriceBookStatus = (payload, token) => priceBookclient.post(`update_status`, payload, { headers: { "Authorization": `Bearer ${token}` } });
export const updatePriceBook = (payload, token) => priceBookclient.put(`edit_pricebook`, payload, { headers: { "Authorization": `Bearer ${token}` } });

export const deletePriceBook = (id, token) =>
  priceBookclient.delete(`delete_booking?order_id=${id}`, {
    headers: { "Authorization": `Bearer ${token}` }
  });

export const getDropdownValue = (token) => priceBookclient.get(`get_dropdown`, { headers: { "Authorization": `Bearer ${token}` } });

export const getCustomers = (token, Country) => priceBookclient.get(`get_customers?country=${Country}`, { headers: { "Authorization": `Bearer ${token}` } });

export const validateFile = (token, formData) =>
  priceBookclient.post(`validate_pricebook`, formData, {
    headers: {
      "Authorization": `Bearer ${token}`,
      "Content-Type": "multipart/form-data"
    }
  });

export const postFileUpload = (token, formData) =>
  priceBookclient.post(`upload_functionality`, formData, {
    headers: {
      "Authorization": `Bearer ${token}`,
      "Content-Type": "multipart/form-data"
    }
  });
